export function toFixedEnhance(num, digits){
    const formatted = num.toFixed(digits);
    return formatted === '-0.00' ? '0.00' : formatted;
}



// WEBPACK FOOTER //
// ./src/util/commonTools.js